if (!customElements.get('mobile-sticky-cart')) {
  customElements.define(
    'mobile-sticky-cart',
    class MobileStickyCart extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        this.normalButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
        this.button = this.querySelector('button');
        if (!this.normalButton || !this.button) return;

        this.button.addEventListener('click', () => this.handleClick());
        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting;
        });
        this.observer.observe(this.normalButton);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.sync(event.data.variant);
        });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      sync(variant) {
        this.normalButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
        const disabled = !this.normalButton || this.normalButton.disabled;
        this.button.disabled = disabled;
        this.button.textContent = this.normalButton?.querySelector('span')?.textContent.trim() || window.variantStrings.unavailable;
        const price = this.productInfo?.querySelector(`#price-${this.dataset.sectionId} .price-item--sale.price-item--last, #price-${this.dataset.sectionId} .price-item--regular`);
        if (price) this.querySelector('.maison-sticky-cart__price').textContent = price.textContent.trim();
        if (variant?.public_title) this.querySelector('.maison-sticky-cart__title').textContent = variant.public_title;
      }

      handleClick() {
        if (this.normalButton && !this.normalButton.disabled) {
          this.normalButton.click();
          return;
        }
        const picker = this.productInfo?.querySelector('variant-selects');
        picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker?.querySelector('input:not([disabled]), select')?.focus({ preventScroll: true });
      }
    }
  );
}
